// extracted by mini-css-extract-plugin
export default {"own":"Select_own__OeP8H","select":"Select_select__XPDXs","dark":"Select_dark__GuRZp","show":"Select_show__j61Ue","label":"Select_label__xG0EM"};